import { render, staticRenderFns } from "./PostJobAgreement.vue?vue&type=template&id=4746f698&scoped=true&"
var script = {}
import style0 from "./PostJobAgreement.vue?vue&type=style&index=0&id=4746f698&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4746f698",
  null
  
)

export default component.exports